import 'googlemaps'
const mapEl = document.getElementById('map')
declare global {
  interface Window {
    initMap: () => void;
  }
}
// consent googleMaps

  var firstMarkerLat = parseFloat(document.querySelector('.marker')?.getAttribute('data-lat') || '');
  var firstMarkerLng = parseFloat(document.querySelector('.marker')?.getAttribute('data-lng') || '');
  var markers = document.querySelectorAll('.marker');
  // Declare the initMap function globally

  window.initMap =()=> {
    // Define the coordinates for the marker
    // Create a new map centered at the marker's coordinates
    const mapEl = document.getElementById('map');
    if (!mapEl) return;
    var markerLatLng = { lat: firstMarkerLat, lng: firstMarkerLng };
    var map = new google.maps.Map(mapEl, {
      center: markerLatLng,
      zoom: 14
    });
  
    for (let index = 0; index < markers.length; index++) {
      const marker = markers[index];
     
      const lat = parseFloat(marker.getAttribute('data-lat') || '');
      const lng = parseFloat(marker.getAttribute('data-lng') || '');
      
      var markerLatLng = { lat: lat, lng: lng };
      var setMarker = new google.maps.Marker({
        position: markerLatLng,
        map: map,
        title: 'Marker Title'
      });
    }
}
